export const CREATE_USER_PERMISSION = "CREATE_USER_PERMISSION";
export const FETCH_USER_PERMISSIONS = "FETCH_USER_PERMISSIONS";
export const FETCH_USER_PERMISSION = "FETCH_USER_PERMISSION";
export const EDIT_USER_PERMISSION = "EDIT_USER_PERMISSION";
export const DELETE_USER_PERMISSION = "DELETE_USER_PERMISSION";
